import { CampaignEditableState } from '../enums'
import * as moment from 'moment-timezone'
import { StatusType } from '../../../enums/status-type'

export const getEditableState = (campaign: any): CampaignEditableState => {
    let state: CampaignEditableState = CampaignEditableState.EDITABLE

    if (campaign?.id && !isNaN(campaign.id) && campaign.statusId !== StatusType.DRAFT.id) {
        const now = moment.utc()
        const dateStartValue = campaign.dateStartUtc || campaign.dateStart
        const dateStart = moment.tz(dateStartValue, 'utc')
        const dateEndValue = campaign.dateEndUtc || campaign.dateEnd
        const dateEnd = !dateEndValue ? null : moment.tz(dateEndValue, 'utc')

        const isCompleted =
            campaign.statusId === StatusType.COMPLETED.id ||
            campaign.dateCompletedUtc ||
            campaign.manuallyCompleted ||
            (dateEnd && dateEnd <= now)

        if (isCompleted) {
            state = CampaignEditableState.COMPLETED
        } else if (dateStart <= now) {
            state = CampaignEditableState.RUNNING
        }
    }

    return state
}

export const getCalculatedStatus = (campaign: any, format?: (status: string, campaign) => string): string => {
    let computedStatus: string = StatusType.SCHEDULED.name

    const now = moment.utc()
    const dateStartValue = campaign.dateStartUtc || campaign.dateStart
    const dateStart = moment.tz(dateStartValue, 'utc')
    const dateEndValue = campaign.dateEndUtc || campaign.dateEnd
    const dateEnd = !dateEndValue ? null : moment.tz(dateEndValue, 'utc')

    const editableState = getEditableState(campaign)
    const editableStateIsCompleted = editableState === CampaignEditableState.COMPLETED

    const statusIsDraft = campaign.status === StatusType.DRAFT.name
    const statusIsCancelled =
        campaign.status === StatusType.CANCELLED.name || campaign.status === StatusType.CANCELLING.name
    const statusIsCompleted =
        campaign.isCompleted() || editableStateIsCompleted || (statusIsDraft && dateEnd && dateEnd <= now)

    if (statusIsCompleted) {
        computedStatus = StatusType.COMPLETED.name
    } else if (statusIsCancelled) {
        computedStatus = StatusType.CANCELLED.name
    } else if (statusIsDraft) {
        computedStatus = StatusType.DRAFT.name
    } else if (dateStart <= now) {
        computedStatus = StatusType.ACTIVE.name
    }

    return !format ? computedStatus : format(computedStatus, campaign)
}

export const generateDefaultSubscriberFcap = () => ({
    criteria: {
        frequency: 1,
        window: 'days',
    },
    type: 'once_per_criteria',
})
